import React from 'react';
const FinancialServices = () => <div className="service-page"><h1>Financial Services</h1><p>Comprehensive financial services for individuals and businesses.</p></div>;
export default FinancialServices;
